
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/help/fraud-prevention/keep-safe",
      function () {
        return require("private-next-pages/help/fraud-prevention/keep-safe.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/help/fraud-prevention/keep-safe"])
      });
    }
  